__webpack_require__.p = "/random-rate/";